import Vue from "vue";
import showError from "@/utils/errorDialog";

const properties = {
  app: {
    menu: {
      color: "blue-grey darken-1",
    },
    primary: {
      color: "cyan darken-3",
    },
    secondary: {
      color: "cyan darken-1",
    },
    title: "モバイルチケット",
    subtitle: "管理コンソール",
    version: "V6",
    // データテーブル表示件数デフォルト値
    defaultPerPage: 100,
    // データテーブル表示件数ALL
    allPerPage: -1,
    // データテーブル総表示件数
    footerProps: { "items-per-page-options": [5, 10, 15, 100, 1000] },
    // ログ画面、チケット検索画面、取引検索画面のデータテーブル総表示件数
    footerPropsMin100: { "items-per-page-options": [100, 500, 1000, 1000] },
  },
  message: {
    error: {
      data_not_found: "データが見つかりません。",
      Auth_Error: "認証失敗",
      Auth_ErrorPermission: "権限なし",
      Request_ErrorParse: "JSONパースエラー",
      Request_ErrorCustomizePermission: "カスタマイズ機能権限なし",
      Request_ErrorDB: "DBアクセスエラー",
      Request_ErrorTicketID: "該当チケットIDなし",
      Request_ErrorTicketStatus: "変更可能なステータスではない",
      Request_ErrorPurchasedTicketID: "該当購入済みチケットIDなし",
      Request_ErrorOrderID: "該当取引IDなし",
      Request_ErrorCreditExpired: "クレジットカード期限切れ",
      Request_ErrorRouteResult: "経路情報取得失敗",
      Request_ErrorUserNotFound: "該当ユーザーなし",
      Request_ErrorParameter: "パラメータ異常",
      Request_ErrorCompanyNotFound: "該当事業者なし",
      Request_ErrorTemplateNotFound: "テンプレートファイル無し",
      Request_ErrorOrderStatus: "変更可能なステータスではない",
      Request_ErrorDeleteUser: "ユーザー情報削除失敗",
      Request_ErrorSaleID: "該当売買IDなし",
      Request_ErrorWriteLog: "ログ書き込み失敗",
      Request_ErrorGetLog: "ログデータ取得失敗",
      Request_ErrorRefund: "返金失敗",
      Request_ErrorSendMail: "一部送信失敗",
      Request_ErrorSendMailAll: "全送信失敗",
      Request_ErrorWriteReport: "帳票書き込み失敗",
      Request_ErrorNotRefundForSuspend: "運休返金対象外",
      Request_ErrorDocomoBikeShareStatus:
        "対象チケットはドコモバイクシェアの自転車を予約中または利用中のため更新できません。ユーザーに自転車の予約キャンセルまたは返却を依頼してください。",
      Request_ErrorRailInfo: "路線情報取得失敗",
      Request_ErrorStationInfo: "駅情報取得失敗",
      Request_ErrorTransportationInfo: "交通機関会社情報取得失敗",
      Request_ErrorSalesOutsidePeriod: "配布期間対象外エラー",
      Request_ErrorDistributionCancelStatus: "配布キャンセルステータスエラー",
      Request_ErrorCreateCloudTasks: "CloudTasks作成失敗",
      Request_ErrorAuthentication: "Authenticationエラー",
      Request_ErrorGetObject: "CloudStrage取得エラー",
    },
  },
  error: showError,
};

Object.defineProperty(Vue.prototype, "$p", {
  get() {
    return properties;
  },
});
